// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f2f1eb;
}
.header-main__content {
  background-color: black;
}
.MasterContainer {
  padding-top: 4em;
  background-color: #f2f1eb;
}
.header-main {
	background-color: black;
}
.header-mobile {
	background-color: black;
}

.sidebar {
  display: none !important;
}
.edit-link {
  display: none;
}

ul.sub-menu {
  width: 20em;
}

.psl-select {
  -webkit-appearance: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/WordpressFixes.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["body {\n  background-color: #f2f1eb;\n}\n.header-main__content {\n  background-color: black;\n}\n.MasterContainer {\n  padding-top: 4em;\n  background-color: #f2f1eb;\n}\n.header-main {\n\tbackground-color: black;\n}\n.header-mobile {\n\tbackground-color: black;\n}\n\n.sidebar {\n  display: none !important;\n}\n.edit-link {\n  display: none;\n}\n\nul.sub-menu {\n  width: 20em;\n}\n\n.psl-select {\n  -webkit-appearance: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
